<template>
  <div class="bg">
    <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-spacer />
              <v-card class="elevation-12">
                <v-toolbar-title>
                  <v-img class="logo mt-2" src="logo-color.png" />
                </v-toolbar-title>
                <v-card-text>
                  <span class="subheading font-weight-medium">{{
                    $t('action.messages.lostPassword')
                  }}</span>
                  <v-text-field
                    v-model="email"
                    v-validate="'required|email'"
                    prepend-icon="person"
                    :label="$t('fields.users.email')"
                    :name="$t('fields.users.email')"
                    :data-vv-name="$t('fields.users.email')"
                    :error-messages="errors.collect($t('fields.users.email'))"
                    @keyup.enter="submit"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <meta-button
                    type="cancel"
                    @click="$router.push({ name: 'login' })"
                  />
                  <v-btn
                    :loading="loading"
                    color="primary"
                    small
                    @click="submit"
                  >
                    {{ $t('action.buttons.recover') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
      <v-footer class="pa-3 footer-bg">
        <span class="caption"
          >FBASE.Tv &copy; {{ new Date().getFullYear() }}</span
        >
        <v-spacer />
        <TermsDialog login @cookies="dialogCookies = true" />
      </v-footer>
    </v-app>
    <dialog-cookies :dialog.sync="dialogCookies" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TermsDialog from '@/components/widgets/Terms'
import DialogCookies from '@/components/widgets/cookies/DialogCookies'
export default {
  components: { TermsDialog, DialogCookies },
  data: () => ({
    email: '',
    dialogCookies: false,
  }),
  computed: mapState({
    loading: (state) => state.auth.loading,
  }),
  methods: {
    ...mapActions({
      lostPassword: 'auth/lostPassword',
    }),
    submit() {
      this.validate().then((valid) => {
        if (!valid) return
        this.lostPassword({
          email: this.email,
          url: this.defaultValues.url,
        })
      })
    },
  },
}
</script>

<style>
.logo {
  margin: auto;
  max-width: 250px;
}
.bg {
  background-image: url('/background.png');
  background-size: cover;
  background-color: #00482b;
}
#inspire {
  background: none;
}
.footer-bg {
  color: white !important;
  background-color: transparent !important;
}
</style>
